export default "__VITE_ASSET__fc17fee3__"